import {
  Box,
  Typography,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  alpha
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ReadableText from '../../../../components/text/ReadableText';

const WordsTable = ({ 
  selectedGlyph,
  displayedWords,
  totalWords,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange
}) => {
  const theme = useTheme();

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Words Using {selectedGlyph} Glyph
      </Typography>
      
      <TableContainer component={Paper} sx={{ 
        mb: 2,
        bgcolor: theme.palette.background.paper,
        borderRadius: 1,
        border: '1px solid',
        borderColor: alpha(theme.palette.common.white, 0.1),
        '& .MuiTableCell-root': {
          borderColor: alpha(theme.palette.common.white, 0.1),
        }
      }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: alpha(theme.palette.common.white, 0.03) }}>
              <TableCell sx={{ fontWeight: 'bold' }}>Word</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Readable Form</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Homophones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedWords.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} align="center" sx={{ py: 3 }}>
                  <Typography variant="body2" color="text.secondary">
                    No words found containing this glyph
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              displayedWords.map((word, index) => (
                <TableRow key={index} sx={{ 
                  '&:nth-of-type(odd)': {
                    bgcolor: alpha(theme.palette.common.white, 0.01)
                  },
                  '&:hover': {
                    bgcolor: alpha(theme.palette.common.white, 0.04)
                  }
                }}>
                  <TableCell>{word.word}</TableCell>
                  <TableCell>
                    <ReadableText text={word.readable} />
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {word.homophones?.length > 0 ? (
                        word.homophones.map((homophone, homophoneIndex) => (
                          <Chip
                            key={homophoneIndex}
                            label={homophone}
                            size="small"
                            variant="outlined"
                            sx={{
                              bgcolor: alpha(theme.palette.info.main, 0.05),
                              color: theme.palette.info.main,
                              borderColor: alpha(theme.palette.info.main, 0.3),
                              fontWeight: 500,
                              fontSize: '0.7rem'
                            }}
                          />
                        ))
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          None
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={totalWords}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={[5, 10, 25, 50]}
        sx={{
          '.MuiTablePagination-toolbar': {
            color: theme.palette.text.secondary,
          },
          '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
            color: theme.palette.text.secondary,
          }
        }}
      />
    </>
  );
};

export default WordsTable;